/**
 * Shared with Profile.jsx and UserFormModal.jsx — keep branch options in one place.
 */
export const PROFILE_BRANCH_MENU_ITEMS = [
  { value: 'CSE - Computer Science & engineering', menuLabel: 'CSE - Computer Science & engineering' },
  { value: 'CSE - AIML', menuLabel: 'CSE - AIML' },
  { value: 'ECE', menuLabel: 'ECE - Electronics and Communication Engineering' },
  { value: 'EEE', menuLabel: 'EEE - Electrical and Electronics Engineering' },
  { value: 'IT', menuLabel: 'IT - Information Technology' },
];

/** Card shell for nested profile blocks — used by ProfileSubsectionCard and Administration card */
export const PROFILE_SUBCARD_SX = {
  elevation: 0,
  mt: 3,
  borderRadius: 2,
  border: 1,
  borderColor: 'divider',
  boxShadow: '0 2px 12px rgba(15, 23, 42, 0.06)',
};

export const PROFILE_SUBCARD_CONTENT_SX = {
  p: { xs: 2, sm: 2.5 },
  '&:last-child': { pb: { xs: 2, sm: 2.5 } },
};
